// Active theme's global stylesheet. The real CSS lives in
// src/themes/<active>/global.js; switch via ACTIVE_THEME in src/themes/index.js.
// App.js keeps doing `import { globalCss } from "./styles/global"` unchanged.
import { theme } from "../themes";

export const globalCss = theme.globalCss;
